import { FileOutlined, LoadingOutlined } from '@ant-design/icons';
import { Spin, Upload, notification } from 'antd';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import { useState } from 'react';
import { FileTypes, MaxSizeFileMB } from 'shared/constants';
import { SizeUnits, convertFileSize } from 'shared/helpers/file';
import { useAbsenceFileUploadMutation } from 'app/services/edpApiV1/absence';
import { useNotifications } from 'shared/hooks/use-notifications';
import { getErrorData } from 'shared/helpers/utils';

const { Dragger } = Upload;

export const UploadDragger = () => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const [uploadTrigger, { isError, isLoading, reset, error }] = useAbsenceFileUploadMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
    fixedCacheKey: 'uploadFile',
  });

  const uploadHandler = (file: RcFile) => {
    const { size, type } = file;

    const isRequiredSize = convertFileSize(size, SizeUnits.MB) < MaxSizeFileMB.excelFile;
    const isRequiredType = type === FileTypes.xlsx || FileTypes.xls;

    if (!isRequiredSize) {
      notification.error({
        message: `Размер файла не должен превышать ${MaxSizeFileMB.excelFile} МБ!`,
      });
      return Upload.LIST_IGNORE;
    }

    if (!isRequiredType) {
      notification.error({
        message: 'Вы можете загрузить только файл в формате xls или xlsx!',
      });
      return Upload.LIST_IGNORE;
    }
    setFileList([file]);
    const data = new FormData();
    data.append('file', file);
    uploadTrigger(data);

    return true;
  };

  useNotifications(false, isError, '', error?.message, reset);

  return (
    <Dragger
      showUploadList={false}
      maxCount={1}
      accept=".xlsx, .xls"
      fileList={fileList}
      beforeUpload={uploadHandler}
      height={150}
    >
      {isLoading ? (
        <Spin indicator={<LoadingOutlined />} />
      ) : (
        <div>
          <p className="ant-upload-drag-icon">
            <FileOutlined />
          </p>
          <p className="ant-upload-text">Выберите файл для загрузки</p>
          <p className="ant-upload-hint">.xls или .xlsx</p>
        </div>
      )}
    </Dragger>
  );
};
